import React,{useEffect,useState} from 'react';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
//import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import useMediaQuery from '@mui/material/useMediaQuery';
import Select,{SelectChangeEvent} from '@mui/material/Select';
import BottomButtons from './BottomButtons';
import InputString from './InputString';
import {Theme} from './Theme';
import {Inc,Dataset,ConsignSheet,ConsignSheetTrackingLength, ConsignSheetMemoLength} from './Inc';
import {Tools} from './Tools';
import useStyles from './Styles';

interface Props {
    consigns: ConsignSheet[],
	index:number,
    yes(consign:ConsignSheet):void,
    no():void,
    isOpen:boolean,
}

const ConsignInput = (props:Props)=> {
    const classes = useStyles();
	const fullScreen = useMediaQuery(Theme.breakpoints.down('sm'));
	const defStates = {
        consign: Inc.defaultConsignSheet(),
		errors: [] as string[],
		hasError: false,
    };
	const [states,setStates] = useState(defStates);

	const onChange = (name:keyof ConsignSheet) => (value: string,hasError: boolean) => {
		//const item = {...states.item,[name]:value};
		validate({...states.consign,[name]:value},name,hasError);
	};
	const onChangeCourier = (event: SelectChangeEvent) => {
		if (!event) {
			return;
		}
		let value = event.target.value;
		validate({...states.consign,courier:value},'配送業者の名称',false);
	}
	const validate = (consign:ConsignSheet,name:string,hasError:boolean)=>{
		let errors = [...states.errors];
		const index = errors.indexOf(name);
		if( index>=0 ){
			if(!hasError){
				errors.splice(index, 1);
			}
		} else {
			if(hasError){
				errors.push(name);
			}
		}
		setStates({...states,consign:consign,errors:errors,hasError:errors.length>0});
	}
	const yes = ()=>{
		props.yes(states.consign);
	}
	const no = ()=>{
		props.no();
	}

	useEffect(()=>{
		if( props.isOpen ){
			let courier = '';
			let other = '';
			if( props.consigns[props.index].courier ){
				let exists = false;
				for( let i=0; i<Inc.couriers.length; i++ ){
					if(Inc.couriers[i].id===props.consigns[props.index].courier){
						exists = true;
					}
				}
				if( exists ){
					courier = props.consigns[props.index].courier;
				} else {
					courier = "その他";
					other = props.consigns[props.index].courier;
				}
			}

			setStates({
				...defStates,
				consign: {
					consign_sheet_id: props.consigns[props.index].consign_sheet_id,
					tracking: props.consigns[props.index].tracking ? props.consigns[props.index].tracking : '',
					courier: courier,
					memo:props.consigns[props.index].memo ? props.consigns[props.index].memo : '',
					other: other,
					regist_time: props.consigns[props.index].regist_time,
				},
			});
		}
	},[props.isOpen]);

	if( !props.isOpen ){
        return (null);
    }


    return (
		<Dialog
			fullScreen={fullScreen}
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.no();
				}
			}}
		>
			<DialogTitle color='primary'>追跡番号の設定</DialogTitle>
			<DialogContent>
				<Grid container spacing={1}>
					<Grid item xs={5}>
						<Select
							label="hai"
							value={states.consign.courier}
							onChange={onChangeCourier}
							variant="standard"
							displayEmpty
							style={{width:'100%',backgroundColor:'#EEEEEE',boxSizing:'border-box',padding:'0.75em 0.5em'}}
						>
							<MenuItem value="" style={{color:'silver'}}>配送業者を選択</MenuItem>
							{Inc.couriers.map((data:Dataset,index:number)=>{
								const key = "courier"+index;
								return <MenuItem value={data.id} key={key}>{data.label}</MenuItem>
							})}
						</Select>
					</Grid>
					<Grid item xs={7}>
						<InputString label="追跡番号" required={false} value={states.consign.tracking} onChange={onChange("tracking")} helper={ConsignSheetTrackingLength+'文字以内（ハイフン不要）'} opt={{rows:1,maxLength:ConsignSheetTrackingLength,placeholder:'000000000000'}}/>
					</Grid>
					<Grid item xs={12}>
						<InputString label="連絡事項" required={false} value={states.consign.memo} onChange={onChange("memo")} helper={Tools.comma(ConsignSheetMemoLength)+'文字以内'} opt={{rows:5,maxLength:ConsignSheetMemoLength}}/>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<BottomButtons button1='登録する' onClick1={yes} button2='やめる' onClick2={no} bottom={0} disabled1={states.errors.length>0}/>
			</DialogActions>
        </Dialog>
    );
}

export default ConsignInput;
